import { render, staticRenderFns } from "./AlertNav.vue?vue&type=template&id=1bc4ed7c"
import script from "./AlertNav.vue?vue&type=script&lang=js"
export * from "./AlertNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports